/**
 * i18n Type Definitions
 * Defines all types for the internationalization system
 */

/**
 * Represents a supported language
 */
export interface Language {
  /** ISO 639-1 language code */
  code: string;
  /** English name of the language */
  name: string;
  /** Native name of the language */
  nativeName: string;
  /** Text direction */
  direction: 'ltr' | 'rtl';
}

/**
 * Translation resources - nested key-value structure
 */
export interface TranslationResources {
  [key: string]: string | TranslationResources;
}

/**
 * Namespace with its translations for a specific language
 */
export interface TranslationNamespace {
  language: string;
  namespace: string;
  resources: TranslationResources;
}

/**
 * List of supported languages
 */
export const SUPPORTED_LANGUAGES: Language[] = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    direction: 'ltr',
  },
  {
    code: 'he',
    name: 'Hebrew',
    nativeName: 'עברית',
    direction: 'rtl',
  },
];

/**
 * Default language code
 */
export const DEFAULT_LANGUAGE = 'en';

/**
 * Fallback language when translation is missing
 */
export const FALLBACK_LANGUAGE = 'en';

/**
 * Available namespaces
 */
export const NAMESPACES = ['common', 'assignEv', 'sessionsReport'] as const;
export type Namespace = (typeof NAMESPACES)[number];

/**
 * Default namespace
 */
export const DEFAULT_NAMESPACE: Namespace = 'common';
